import { ITypeaheadProps } from "./components";
import { Typeahead } from "./Typeahead";
import { withChildren } from "./withChildren";

export interface ITypeaheadWithChildrenProps extends ITypeaheadProps {
  childrenKey?: string;
}

export const TypeaheadWithChildren = withChildren<ITypeaheadWithChildrenProps>(Typeahead);
